import React from 'react';
import { confirmable, createConfirmation } from 'react-confirm';
import { FaExclamationTriangle } from "react-icons/fa";

const Confirmation = ({ show, proceed, title, message }) => (
  <div
    className={`modal fade ${show ? 'show' : 'hide'}`}
    style={{
      display: show ? "flex" : "none",
      backgroundColor: "rgba(0,0,0,.15)",
      alignItems: "center",          // vertical centering
      justifyContent: "center",      // horizontal centering
      minHeight: "100vh"             // full viewport height
    }}
    role="dialog"
    onClick={() => proceed(false)}
  >
    <div
      className="modal-dialog modal-lg modal-dialog-centered"
      role="document"
      onClick={(e) => e.stopPropagation()} // prevent closing when clicking inside
    >
      <div className="modal-content" style={{ color: 'darkblue' }}>
        <h5 className="popupTitle">{title}</h5>

        <p className="popup-text">{message}</p>

        <FaExclamationTriangle
          style={{ width: "256px", height: "256px", display: "block", margin: "0 auto", color:"orange" }}
        />

        <div
          className="modal-actions"
          style={{
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '10px'
          }}
        >
          <button
            className="btn btn-cancel"
            onClick={() => proceed(false)}
          >
            NO
          </button>

          <button
            className="btn btn-save"
            onClick={() => proceed(true)}
          >
            YES
          </button>
        </div>
      </div>
    </div>
  </div>
);

export const confirmDelete = createConfirmation(confirmable(Confirmation));